<a href="/gallery">
  <button nbButton size="tiny" status="primary" shape="round">Browse Full Gallery</button>
</a>

<div class="row">
  <div class="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2">
    <app-gallery-searchbar
      [fieldSize]="'medium'"
      (searchTerm)="reset($event)"
    ></app-gallery-searchbar>
  </div>
</div>

<app-doc-scroller [recordSize]="isHandset ? 440 : 375" (updateQueries)="search($event)">
  <ng-template let-doc="doc">
    <div class="row">
      <div [ngClass]="{ 'col-xs-12': isHandset, 'col-xs-3': !isHandset }" *ngFor="let d of doc">
        <app-gallery-record-card [record]="d"></app-gallery-record-card>
      </div>
    </div>
  </ng-template>
</app-doc-scroller>
